import { useEffect, useState, useContext } from 'react';
import  TextField  from '@mui/material/TextField';
import Storage from '../../../session/storage';
import Autocomplete from '@mui/material/Autocomplete';
import CONSTANT from '../../../Constant/Constant';
import { sortTranslated } from '../../shared/util';
import { DropdownContext } from '../../../context/DropDownContext';
import { UiPicklistContext } from '../../../context/UiPicklistContext';
import profileData from '../../../config/ProfileDetailsData.json';
import prefferedLanguage from '../../../config/preffered_language.json';

const InputDetails = (props) => {
    const { uiDropdownValue } = useContext(UiPicklistContext);
    const [value, setValue] = useState(props.value || null)
    const [lengthFlag, setFlag] = useState();
    const [label, setLabel] = useState(props.label);
    const [invalidInputFlag , setInvalidInputFlag ] = useState(false)
    const [mainInfoData, setmainInfoDatat ] = useState(props.newValue.find((el) => {
        return el.id === 'mainInfo'
    }));
    const [contactdata, setContactDatat ] = useState(props.newValue.find((el) => {
        return el.id === 'contactData'
    }));
    const { dropdownvalue } = useContext(DropdownContext);
    const sourceData  = profileData

    /**
     * map name to key
     * @param {*} name name of attribute
     * @returns key name of attribute
     */
    const getOptionKey = (name, vendor) => {
        switch (name) {
            case 'Classification Code':
                if (vendor == "VNDR-VN") {
                    return 'Classification';
                  }
                return 'Classification';
            case 'Sub Classification Code':
                return 'SubClassification';
            case 'Prefix':
                if (vendor == "VNDR-VN") {
                    return 'Title'
                  }
                return 'Title';
            case 'Other Specialty':
                return 'Specialty';
            case 'Primary Specialty':
                return 'Specialty'
            case 'Specialty Type':
                return 'SpecialtyType';
                case 'Identifiers Type':
                    return 'AltIDType';
                case 'Identifiers Sub Type':
                    return 'AltIDSubtype';        
                        
            case 'Country':
                return 'Country';     
            case 'Country Code':
                return 'Country';
            case 'Gender':
                return 'Gender';
            case 'Preferred Language':
                return 'PreferredLanguage';  
            default:
                return name;

                
        }
    }

    const  onlyUnique = (value, index, array) => {
        return (array.indexOf(value) === index)
      }
      

    /**
     * Map name to ID
     * @param {*} name 
     * @returns ID of atrribute
     */
    const getId = (name, vendor) => {
        switch (name) {
            case 'Classification Code':
                if (vendor == "VNDR-VN") {
                    return 'ClassificationCode';
                  }
                return 'ClassificationCode';
            case 'Sub Classification Code':
                return 'SubClassificationCode';
            case 'Suffix Name':
                return 'SuffixName';
            case 'Middle Name':
                return 'MiddleName';
            case 'Primary Specialty':
                return 'PrimarySpecialty';
            case 'Other Specialty':

                return 'OtherSpecialty';
     
            case 'Identifiers Type':
                return 'Type';
            case 'Identifiers Sub Type':
                return 'SubType'; 
            case 'Prefix':
                if (vendor == "VNDR-VN") {
                    return 'Title';
                }
                return 'Prefix';
            case 'Gender':
                return 'Gender';
            case 'Preferred Language':
                return 'PreferredLanguage';   

            default:
                return name;
        }
    }

    let options =  (sourceData.OPEN_DATA_SOURCES.includes(props.sourceName) ? CONSTANT.LOV_BOUNDED_OPTION_SPCIAL_CASE.includes(getId(label.trim())) :  CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim()))) ? Storage.getLovBoundedList() : Storage.getPickList()['HCP'];
    options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {HCP:{[label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] }} : options;

    let option;
    option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined :options?.HCP[getOptionKey(label?.trim(), props.vendor)];
    // const [option, setOption] = useState(CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined :options?.HCP[getOptionKey(label?.trim(), props.vendor)]);
    const unique_option = option?.filter(onlyUnique)
    const [required, setRequired] = useState(); 
    if (getId(label.trim()) === 'PreferredLanguage') {
        //    setOption(prefferedLanguage.PreferredLanguages['VNDR-CGDM'])
        if (props?.vendor === 'VNDR-CGDM') {
                let country = props?.countryName || "default";
                option = prefferedLanguage.PreferredLanguages['VNDR-CGDM'][country] || prefferedLanguage.PreferredLanguages['VNDR-CGDM']['default'];
            } else {
                option = prefferedLanguage.PreferredLanguages['MNGD-AFF']
            }
    }
    
     useEffect(() => {
       if(dropdownvalue === undefined || dropdownvalue === null || dropdownvalue.length === 0) return;
        options = CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim(), props.vendor)) ? dropdownvalue : uiDropdownValue['HCP'];
        options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? {HCP:{[label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] }} : options;
        option = CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options?.HCP[getOptionKey(label?.trim(), props.vendor)];
        // setOption(CONSTANT.STASTIC_ATTRIBUTE.includes(label.trim()) ? undefined : options?.HCP[getOptionKey(label?.trim(), props.vendor)]);
        if (getId(label.trim()) === 'PreferredLanguage') {
            if (props?.vendor === 'VNDR-CGDM') {
                let country = props?.countryName || "default";
                option = prefferedLanguage.PreferredLanguages['VNDR-CGDM'][country] || prefferedLanguage.PreferredLanguages['VNDR-CGDM']['default'];
            } else {
                option = prefferedLanguage.PreferredLanguages['MNGD-AFF']
            }
        }
    
    },[dropdownvalue])

    /**
     * Pass value to parent
     * @param {*} event 
     */
    const passToParent = async (event) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue(event.target.value)
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    /**
     * Handel Input Change
     * @param {*} event : event
     * @param {*} passTo : parent flag
     * @param {*} reqFlag : validation flag
     */
    const handelInput = (event, passTo, reqFlag) => {

        mainInfoData?.attributes?.map((el)=>{
          
            if(event.target.name === el.name && el.pattern){

               
                if(event.target.value.match(el.pattern.includes('+') ? el.pattern.replace('+',"\\s") : el.pattern )){
               
                    setInvalidInputFlag(false)
                }
                else{
                   
                    setInvalidInputFlag(true)
                    
                }
            }
            return({})

        })

       contactdata?.attributes?.map((el)=>{
          
        if(event.target.name === el.name && (el.pattern)){
            
            if(event.target.value.match(el.pattern)){
          
                setInvalidInputFlag(false)
            }
            else{
                
                setInvalidInputFlag(true)
                
            }
        }
        return({})

    })

        
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue(event.target.value)

        if (passTo) {
            passToParent(event)
        }
    }

    useEffect(() => {
        let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
       // setRequired(props.newHCP !== undefined ? CONSTANT.REQUIRED_HCP.includes(label.trim()) : !CONSTANT.OPTIONAL.includes(getId(label.trim())))
        setRequired(props.newHCP !== undefined ? props.require: false)
       
        
        if (props.clear && option === undefined) {
            setValue('')
        } else if (props.clear && option !== undefined) {
            setValue(null)
        }
    }, [props.clear, option, props.error, value, label, props.newHCP,props.require])

    return (
        <>
            {
                props.date === false && option !== undefined && !['Gender', 'Preferred Language'].includes(label) &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                    key={label}
                    onChange={(event, value) => 
                        handelInput({
                          target: { 
                            value: label.trim() === 'Other Specialty' 
                              ? value.length > 0 
                                ? value.map(res => res.split('//')[0]) 
                                : value 
                              : value?.split('//')[0].length > 0 
                                ? value.split('//')[0] 
                                : value 
                          }
                        }, true)}                      
                    options={option.flatMap(group => sortTranslated(group.options))}
                    getOptionLabel={(option) => option.split('//')[0]}
                    groupBy={(option) => {return option.includes('//UnClassified') ? 'Unclassified' :`HCP - ${label} ` }}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "}
                            variant ="standard" id="varantOptionTxT"/>}
                />
            }
            {
                props.date === false && option !== undefined && ['Preferred Language'].includes(label) &&
                <Autocomplete
                    value={
                        typeof value === 'string'
                            ? option
                                ?.flatMap(g => g.options ?? g)
                                ?.find(
                                    opt =>
                                        opt?.split('//')[0]
                                            ?.split(' | ')
                                            ?.pop()
                                            ?.trim() === value
                                ) ?? value
                            : null
                    }

                    options={option?.flatMap(g => g.options ?? g) ?? []}

                    getOptionLabel={(option) =>
                        typeof option === 'string'
                            ? option.split('//')[0]
                            : ''
                    }

                    isOptionEqualToValue={(option, value) =>
                        option?.split('//')[0] === value?.split('//')[0]
                    }

                    onChange={(event, selected) => {
                        const finalValue =
                            typeof selected === 'string'
                                ? selected.split('//')[0].split(' | ').pop().trim()
                                : null;

                        handelInput(
                            { target: { value: finalValue } },
                            true
                        );
                    }}

                    groupBy={(optionValue) =>
                        optionValue?.includes('//UnClassified')
                            ? 'Unclassified'
                            : `HCP - ${label}`
                    }

                    id={label}
                    name={label}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            error={lengthFlag && required}
                            helperText={
                                lengthFlag && required
                                    ? 'Please Select One Option'
                                    : ' '
                            }
                        />
                    )}
                />

            }
            
            {
                props.date === false && option !== undefined && ['Gender'].includes(label) &&
                    <Autocomplete
                        value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                        key={label}
                        onChange={(event, value) => 
                            handelInput({
                            target: { 
                                value: label.trim() === 'Other Specialty' 
                                ? value.length > 0 
                                    ? value.map(res => res.split('//')[0]) 
                                    : value 
                                : value?.split('//')[0].length > 0 
                                    ? value.split('//')[0] 
                                    : value 
                            }
                            }, true)}                      
                        options={option}
                        getOptionLabel={(option) => option}
                        groupBy={()=> {return `HCP - ${label}`}}
                        id={label}
                        name={label}
                        multiple={label.trim() === 'Other Specialty'}
                        renderInput={(params) =>
                            <TextField {...params} error={(lengthFlag) && required}
                                helperText={((lengthFlag) && required) ? "Please Select One Option" : " "}
                                variant ="standard" id="varantOptionTxT"/>}
                />
            }
            {
                props.date === true && props.type !== 'number' && option === undefined &&
                <TextField
                    
                    value={value || ''}
                    id={label}
                    name={label}
                    onChange={handelInput}
                    error={(lengthFlag) && required }
                    helperText={((lengthFlag) && required ) ?  <span id="input-text">Please Enter Valid Input</span> : " "}
                    onBlur={passToParent}
                    className="w-100 input-text"
                    type="date"
                    inputProps={{ max: "9999-12-31" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            {
                props.date === false && option === undefined &&
                < TextField
                
                    type={props.type}
                    key={label}
                    error={(lengthFlag && required) || invalidInputFlag}
                    helperText={((lengthFlag && required) || invalidInputFlag) ? <span id="input-text">Please Enter Valid Input</span> : " "}
                    value={(value || '')}
                    onChange={handelInput}
                    onBlur={passToParent}
                    id={label}
                    name={label}
                    variant ="standard"
                    color="primary" className="w-100 input-text" />
            }
        </>
    )

}

export default InputDetails;